import React from 'react';
import { Box, Typography, Container } from '@mui/material';

const UrlManagementPage: React.FC = () => {
  return (
    <Container maxWidth="xl">
      <Box sx={{ py: 3 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          URL Management
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Manage and track your website URLs and page performance.
        </Typography>
        {/* URL management components will be added here */}
      </Box>
    </Container>
  );
};

export default UrlManagementPage;